import styled from 'styled-components';
import {
    HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS,
    FONT_PROPERTIES,
    BORDER_PROPERTIES,
    FOCUS_CSS,
} from 'common/components/TouchpointEditor/components/TouchpointContainer';

export const ZoomGatedEmbedContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    align-items: center;
`;

export const Headline = styled.h2`
    ${FONT_PROPERTIES}

    ${HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS}
`;

export const Button = styled.button`
    display: inline-block;
    padding: 0.75rem 1.5rem;
    background-color: ${(props) => props.$backgroundColor};
    word-break: break-word;
    text-align: center;
    border-style: solid;
    cursor: pointer;

    ${FONT_PROPERTIES}
    ${BORDER_PROPERTIES}
    ${FOCUS_CSS}

    &:hover {
        background-color: ${(props) => props.$backgroundColorHover};
        color: ${(props) => props.$fontColorHover};
        border-color: ${(props) => props.$borderColorHover};
    }

    ${HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS}
`;

export const ZoomEmbedMessage = styled.p`
    ${FONT_PROPERTIES}

    ${HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS}
`;
